import React, { Suspense } from "react";
import "./App.css";
import RoutesWrapper from "./routes/route-wrapper";
import { Toaster } from "sonner";
import WhatsAppSupport from "./components/whatsapp";
import ChunkErrorBoundary from "./components/chunk-error-boundary";

// Global loading component
const GlobalLoader = () => (
  <div className="flex justify-center items-center min-h-screen bg-white">
    <div className="flex flex-col items-center gap-4">
      <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#00A86B]"></div>
      <p className="text-sm text-gray-500">Loading application...</p>
    </div>
  </div>
);

function App() {
  return (
    <ChunkErrorBoundary>
      <Suspense fallback={<GlobalLoader />}>
        <WhatsAppSupport />
        <RoutesWrapper />
        <Toaster
          position="top-right"
          duration={4000}
        />
      </Suspense>
    </ChunkErrorBoundary>
  );
}

export default App;